import React,{useState, useEffect} from 'react'
import {
	useSelector,
	useDispatch
} from 'react-redux'
import Popover from 'react-bootstrap/Popover'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Button from 'react-bootstrap/Button'
import {updateNutrtionSimplifiedFood} from '../../../state/events'
import classes from './SimplifiedNutrition.module.css'

const AmountSelector = ({icon,nutrition_id,foodData, handleWater}) =>{
	const dispatch = useDispatch()
	const {id:food_id} = foodData
	const {quantity} = foodData
	const [completed,setCompleted] = useState(foodData.completed)
	

	const wholeCount = Math.floor(completed)
	
	const quarterAmount = completed-wholeCount
	
	const getWidthPercent = (completed,idx)=>{
		return Math.max(Math.min(completed - idx,1),0)*100
	}
	
	const dispatchUpdate = (completed,id)=>{
		dispatch(updateNutrtionSimplifiedFood({
			completed, id, nutrition_id
		}))
	}

	// const getCompleted = (completed, amount, index) => {
	// 	console.log('completed, amount, index: ', completed, amount, index)
	// }

	const completedOptions = [
		{
			text:'1/4',
			amount:1/4
		},{
			text:'1/3',
			amount:1/3
		},{
			text:'1/2',
			amount:1/2
		},{
			text:'2/3',
			amount:2/3
		},{
			text:'3/4',
			amount:3/4
		},{
			text:'1',
			amount:1
		},
	]

	const waterOptions = [
		{
			text:'2 oz',
			amount:1/4
		},{
			text:'4 oz',
			amount:1/2
		},{
			text:'6 oz',
			amount:3/4
		},{
			text:'8 oz',
			amount:1
		},
	]

	return (
		<div>
			{[...Array(quantity)].map((_,i)=>(
				<OverlayTrigger rootClose key={`food-${food_id}-${i}`} trigger="click" overlay={
					<Popover>
						<Popover.Content>
							{foodData.name==='water'? 
							<ButtonGroup>
							{waterOptions.map(opt=>(
								<Button onClick={()=>{
									const newCompleted = i+opt.amount
									dispatchUpdate(newCompleted,food_id)
									setCompleted(newCompleted)
									handleWater(newCompleted)
								}} variant="outline-primary" size="sm">{opt.text}</Button>
							))}
							</ButtonGroup>
							:
							<ButtonGroup>
							{completedOptions.map(opt=>(
								<Button onClick={()=>{
									const newCompleted = i+opt.amount
									dispatchUpdate(newCompleted,food_id)
									setCompleted(newCompleted)
								}} variant="outline-primary" size="sm">{opt.text}</Button>
							))}
							</ButtonGroup>
							
							}

						</Popover.Content>
					</Popover>
				}>
					<button 
						className={[
							"m-1",
							classes.CompletionOrb
						].join(' ')}>
						<div style={{
							left:0,
							top:0,
							position:'absolute',
							height:'100%',
							width:`${getWidthPercent(completed,i)}%`,
							backgroundColor:'#00ff8c'
						}} />
						<img style={{maxHeight:'70%',maxWidth:'70%',position:'relative',zIndex:'2'}} src={icon}/>
					</button>
				</OverlayTrigger>
			))}
		</div>
	)
}

const SimplifiedFoods = ({nutrition_id,foods})=>{

	const [waterAmount,setWaterAmount] = useState(0)

	useEffect(() => {
		foods.forEach(food=>{
			if(food.name==='water'){
				setWaterAmount(food.completed*8)
			}
		})
	},[]) // doesnt work if the [] is missing

	const iconMap = {
		protein:"fish.svg",
		carbs:"carbs.svg",
		carbohydrates:"carbs.svg",
		healthyFat:"avocado.svg",
		'healthy fat':"avocado.svg",
		fruit:"apple.svg",
		vegetables:"broccoli.svg",
		water:"beverage.svg"
	}
	const path = window.location.host === 'localhost:3000' ? '/icons/food/svg/' : '/assets/img/icons/food/svg/'
	
	const handleWater = (completed) => {
		setWaterAmount(completed*8)
	}

	return (
		<div>
			{foods.map(food=>(
				<div key={food.id}>
					{food.name === 'water'? 
					<div>{food.name}: {waterAmount} ounces</div>
					: 
					<div>{food.name}</div>
					}

					<AmountSelector
						nutrition_id={nutrition_id}
						foodData={food}
						icon={`${path}${iconMap[food.name]}`}
						handleWater={handleWater}
						/>
				</div>
			))}
		</div>
	)
}

export default SimplifiedFoods